export const Steps: any = {
  arrival: {
    detail:
      "Please drop your vehicle onsite and it will be ready for its pre-repair inspection.",
    detailAfter:
      "Your vehicle has been dropped and it's on our workshop being repaired.",
    status: "Vehicle not yet onsite",
    isZero: true,
    labelBefore: "Awaiting arrival",
    labelAfter: "Arrived",
    stepStatus: "NotStarted",
    completedMessage: "",
    isAccordion: false,
    icon: "FaRegClock",
  },
  preCheck: {
    detail:
      "A job sheet outlining all the needed repair work will then be created relayed to our technicians.",
    detailAfter:
      "A job sheet outlining all the needed repair work has been created and it's ready for view",
    status: "Pre-repair Inspection",
    video: "https://youtu.be/EBvhn-tJHNY",
    labelBefore: "Pre-repair Inspection",
    labelAfter: "Pre-repair Inspection",
    stepStatus: "",
    completedMessage: "",
    isAccordion: false,
    icon: "FaRegFileAlt",
  },
  suppCheck: {
    detail:
      "You will receive an update regarding the completion date of the repair.",
    detailAfter:
      "Your vehicle has been reassessed and collection date updated if necessary.",
    status: "Supplementary Check",
    video: "https://youtu.be/EBvhn-tJHNY",
    labelBefore: "Supplementary Check",
    labelAfter: "Supplementary Check",
    stepStatus: "",
    completedMessage: "",
    isAccordion: false,
    icon: "FaRegListAlt",
  },
  repair: {
    detail: "The repairs are being carried out at this stage.",
    detailAfter: "The repairs have been completed successfully",
    status: "Repair",
    video: "https://youtu.be/EBvhn-tJHNY",
    labelBefore: "Repair",
    labelAfter: "Repair",
    stepStatus: "NotStarted",
    completedMessage: "",
    subTasks: {
      strip: {
        detail:
          "Your vehicle will be carefully stripped to assess any further damage or required parts or repair work.",
        status: "Strip",
        video: "https://youtu.be/EBvhn-tJHNY",
        labelBefore: "Strip",
        stepStatus: "",
        completedMessage: "",
      },
      repair: {
        detail: "The repairs are then carried out at this stage.",
        status: "Repair",
        video: "https://youtu.be/EBvhn-tJHNY",
        labelBefore: "Repair",
        stepStatus: "",
        completedMessage: "",
      },
      prime: {
        detail:
          "Your vehicle’s repairs will be sealed in, primed and prepped for refinishing.",
        status: "Prime",
        video: "https://youtu.be/EBvhn-tJHNY",
        labelBefore: "Prime & Prep",
        stepStatus: "",
        completedMessage: "",
      },
      prep: {
        detail:
          "Your vehicle’s repairs will be sealed in, primed and prepped for refinishing.",
        status: "Prime",
        video: "https://youtu.be/EBvhn-tJHNY",
        labelBefore: "Prime & Prep",
        stepStatus: "",
        completedMessage: "",
      },
      paint: {
        detail:
          "Your vehicle is then colour matched and painted using leading-edge paints by Octoral.",
        status: "Prep",
        video: "https://youtu.be/EBvhn-tJHNY",
        labelBefore: "Paint",
        stepStatus: "",
        completedMessage: "",
      },
      refit: {
        detail:
          "Our technicians then carefully and methodically reassemble the vehicle back to its pre-accident state.",
        status: "Paint",
        video: "https://youtu.be/EBvhn-tJHNY",
        labelBefore: "Refit",
        stepStatus: "",
        completedMessage: "",
      },
      detail: {
        detail:
          "Your vehicle is then checked for any imperfections in the paint and detailed and cleaned.",
        status: "Refit",
        video: "https://youtu.be/EBvhn-tJHNY",
        labelBefore: "Detail ",
        stepStatus: "",
        completedMessage: "",
      },
    },
    isAccordion: true,
    icon: "FaTools",
  },
  postCheck: {
    detail:
      "A job sheet comparing the pre-repair inspection will be created relayed to our technicians.",
    detailAfter:
      "A job sheet comparing the pre-repair inspection has ben created by our technicians.",
    status: "Detailing",
    video: "https://youtu.be/EBvhn-tJHNY",
    labelBefore: "Post-Check",
    labelAfter: "Post-Check",
    stepStatus: "",
    completedMessage: "",
    isAccordion: false,
    icon: "FaCheckDouble",
  },
  complete: {
    detail:
      "A notification will be sent to you once your car is ready for pickup, all good as new!",
    detailAfter: "Congratulations, your vehicle repair is completed!",
    status: "Ready for Pickup",
    video: "https://youtu.be/EBvhn-tJHNY",
    labelBefore: "Complete",
    labelAfter: "Completed",
    stepStatus: "NotStarted",
    completedMessage: "",
    isAccordion: false,
    icon: "FaRegCheckCircle",
  },
  collect: {
    detail: "Your vehicle will be ready ready to be collected.",
    detailAfter: "Your vehicle has been collected!",
    status: "Completed",
    video: "",
    labelBefore: "Estimated Collection",
    labelAfter: "Collected",
    stepStatus: "NotStarted",
    completedMessage: "",
    isAccordion: false,
    icon: "FaRegCalendarCheck",
  },
};
